import React, { useState } from "react";
import Swal from "sweetalert2";
import { BASE_URL } from "../Config";

const Register = () => {
  const [formData, setFormData] = useState({
    firmName: "",
    address: "",
    firmMobile: "",
    firmAlternateMobile: "",
    area: "",
  });

  const [representatives, setRepresentatives] = useState([
    { name: "",  mobile: "" }
  ]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleRepChange = (index, field, value) => {
    const updatedReps = [...representatives];
    updatedReps[index][field] = value;
    setRepresentatives(updatedReps);
  };

  const addRepresentative = () => {
    if (representatives.length < 5) {
      setRepresentatives([
        ...representatives,
        { name: "",  mobile: "" }
      ]);
    }
  };

  const removeRepresentative = (index) => {
    setRepresentatives(representatives.filter((_, i) => i !== index));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = { ...formData, representatives };

    try {
      const response = await fetch(`${BASE_URL}/api/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

     
        Swal.fire("Application Submitted Successfully", result.message, "success");
        setFormData({
          firmName: "",
          address: "",
          firmMobile: "",
          firmAlternateMobile: "",
          area: "",
        });
        setRepresentatives([{ name: "",  mobile: "" }]);
    
    } catch (error) {
      Swal.fire("Error", "Network error. Please try again.", "error");
    }
  };

  return (
    <section className="py-5 bg-light">
      <div className="container">
        <form
          onSubmit={handleSubmit}
          className="mx-auto bg-white p-4 rounded shadow"
          style={{ maxWidth: "900px", textAlign: "left" }}
        >
          <h2 className="text-center text-dark mb-3">
            Membership Registration Form
          </h2>
          <hr />

          {/* Firm Name */}
          <div className="form-group mb-2">
            <label>Firm Name</label>
            <input
              type="text"
              name="firmName"
              className="form-control"
              value={formData.firmName}
              onChange={handleChange}
              required
            />
          </div>

          {/* Address */}
          <div className="form-group mb-2">
            <label>Address</label>
            <input
              type="text"
              name="address"
              className="form-control"
              value={formData.address}
              onChange={handleChange}
              required
            />
          </div>

          {/* Firm Mobile */}
          <div className="form-group mb-2">
            <label>Firm Mobile No. (WhatsApp without +91)</label>
            <input
            type="text"
            name="firmMobile"
            className="form-control"
            value={formData.firmMobile}
            onChange={(e) => {
              // Only allow numbers and limit to 10 characters
              const value = e.target.value.replace(/\D/g, '').slice(0, 10);
              handleChange({ target: { name: 'firmMobile', value } });
            }}
            pattern="\d{10}"
            maxLength={10}
            required
          />
          </div>

          {/* Firm Alternate Mobile */}
          <div className="form-group mb-2">
            <label>Firm Alternate Mobile</label>
            <input
              type="text"
              name="firmAlternateMobile"
              className="form-control"
              value={formData.firmAlternateMobile}
              onChange={handleChange}
            />
          </div>

          {/* Area */}
          <div className="form-group mb-3">
            <label>Area</label>
            <input
              type="text"
              name="area"
              className="form-control"
              value={formData.area}
              onChange={handleChange}
              required
            />
          </div>

          <hr />
          <h5>Contact Persons(Up to 5)</h5>

          {/* Representatives Rows */}
          {representatives.map((rep, index) => (
            <div
              key={index}
              className="d-flex align-items-end gap-2 mb-3"
            >
              {/* Name */}
              <div className="flex-fill">
                <label>Representative Name</label>
                <input
                  type="text"
                  className="form-control"
                  style={{ backgroundColor: "#f8ebf1" }}
                  value={rep.name}
                  onChange={(e) =>
                    handleRepChange(index, "name", e.target.value)
                  }
                  required
                />
              </div>

             
              {/* Mobile */}
              <div className="flex-fill">
                <label>Representative Mobile</label>
                <input
                  type="text"
                  className="form-control"
                  style={{ backgroundColor: "#f8ebf1" }}
                  value={rep.mobile}
                  onChange={(e) =>
                    handleRepChange(index, "mobile", e.target.value)
                  }
                  required
                />
              </div>

              {/* Add/Remove Button */}
              <div>
                {index === representatives.length - 1 &&
                representatives.length < 5 ? (
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={addRepresentative}
                  >
                    Add
                  </button>
                ) : (
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={() => removeRepresentative(index)}
                  >
                    Remove
                  </button>
                )}
              </div>
            </div>
          ))}

          {/* Submit */}
          <div className="form-group text-end mt-4">
            <button type="submit" className="btn btn-success px-4">
              Submit
            </button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default Register;
